(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
      this.lastScrollTop = 0;
      this.isHidden = false;
      this.headerHeight = 0;
      this.scrollTimeout = null;
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerHeight = this.offsetHeight;
      
      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        this.header.classList.toggle('shopify-section-header-menu-open');
      });

      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      // At the very top - show header normally (not sticky)
      if (scrollTop <= 0) {
        this.header.classList.remove('shopify-section-header-sticky', 'shopify-section-header-hidden');
        document.body.classList.remove('shopify-body-section-header-sticky', 'shopify-body-section-header-hidden');
        this.isHidden = false;
        this.lastScrollTop = scrollTop;
        return;
      }

      // Once we've scrolled past the header, make it sticky
      if (scrollTop > this.headerHeight) {
        this.header.classList.add('shopify-section-header-sticky');
        document.body.classList.add('shopify-body-section-header-sticky');

        // Check scroll direction
        if (scrollTop > this.lastScrollTop) {
          // Scrolling DOWN - hide header (only once)
          if (!this.isHidden) {
            this.header.classList.add('shopify-section-header-hidden');
            document.body.classList.add('shopify-body-section-header-hidden');
            this.isHidden = true;
          }
        } else {
          // Scrolling UP - show header
          if (this.isHidden) {
            this.header.classList.remove('shopify-section-header-hidden');
            document.body.classList.remove('shopify-body-section-header-hidden');
            this.isHidden = false;
          }
        }
      }

      this.lastScrollTop = scrollTop;
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
